import '../styles/contribution.css'
import Icon9 from './Icon9.jsx'

function ContributionTitle2() {
    return (
        <div id='contribution_title_display2'>
            <div id='contribution_title2'>
                <div id='contribution_title_icon2'>
                    <Icon9 />
                </div>
                <div id='contribution_title_text2'>Creations</div>
            </div>
        </div>
    )
}

export default ContributionTitle2